import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../work-orders.service';
import { WorkOrderHistoryService } from '../../ve.service';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'work-order-history',
  templateUrl: './work-order-history.component.html',
  styleUrls: ['./work-order-history.component.scss']
})
export class WorkOrderHistoryComponent extends DataGridTemplate implements OnInit {
  editForm: UntypedFormGroup;
  workOrdersService: WorkOrdersService;
  workOrderHistoryService: WorkOrderHistoryService;
  columns: any[];

  constructor(injector: Injector) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.workOrderHistoryService = injector.get(WorkOrderHistoryService);
    this.editForm = this.workOrdersService.userModule === 'VE_Body'
      ? this.workOrdersService.bodyMainEditForm
      : this.workOrdersService.workOrderDetailsForm;
  }

  ngOnInit() {
    this.setControls();
    this.setColumns();
    this.gridState.sort = [{ field: 'AuditDto.ModifiedDate', dir: 'desc' }];
    this.columnMenu = false;
    this.height = '100%';
  }

  read(opts: any): Promise<any> {
    const woId = this.editForm ? this.editForm.get('Id').value : null;
    if (woId) {
      return this.workOrderHistoryService.read('/' + woId)
      .then(response => {
        if (response) {
          response.forEach(element => {
            const date = new Date(element.AuditDto.ModifiedDate);
            element.Date = date.toLocaleString();
          });
          return response;
        }
      });
    } else {
      return null;
    }
  }

  create(parentEditDataItem: any): void { 
    //this is kept empty on purpose
  }

  edit(dataItem: any): void {
    //this is kept empty on purpose
   }

  delete(dataItem: any): Promise<any> { return null; }

  save(dataItem: any, isNew: boolean): Promise<any> { return null; }

  private setColumns() {
    this.columns = [
      {
        field: 'Action',
        width: 360,
        title: 'Action'
      },
      {
        field: 'Description',
        width: 360,
        title: 'Description'
      },
      {
        field: 'AuditDto.ModifiedBy',
        width: 360,
        title: 'Performed By'
      },
      {
        field: 'Date',
        width: 360,
        title: 'Date'
      }
    ];
  }

  private setControls() {
    this.controls.excel = false;
    this.controls.delete = false;
    this.controls.edit = false;
    this.controls.add = false;
  }
}
